import { SortableHandle } from '@alexcheuk/react-sortable-hoc'

import { DragHandleStyled, SortableTagStyled } from './styles/SortableTagStyled'
import { type SortableTagsCommonProps } from '../../types'
import { Flex } from '@ui/elements/Flex'
import { Text } from '@ui/elements/Text'

export interface ISortableTagProps<TagValue = any>
  extends SortableTagsCommonProps<{
    value: TagValue
    sortIndex?: number
  }> {}

const DragHandle = SortableHandle(() => <DragHandleStyled>::</DragHandleStyled>)

export const SortableTag = <TagValue,>({
  innerProps,
  ...commonProps
}: ISortableTagProps<TagValue>) => {
  const {
    sortableTagsProps: {
      showDragHandle,
      showOrderNumber,
      tagWidth,
      layout,
      components,
    },
  } = commonProps
  return (
    <SortableTagStyled width={tagWidth} layout={layout}>
      <div className='sortable-tag-container'>
        <Flex.Row alignItems='center' flexWrap='nowrap' width='100%' m={0}>
          {showDragHandle && (
            <Flex.Item p={0}>
              <DragHandle />
            </Flex.Item>
          )}
          {showOrderNumber && (
            <Flex.Item p={0.5}>
              <Text className='order-number'>{innerProps.sortIndex + 1}</Text>
            </Flex.Item>
          )}
          <Flex.Item p={0} flexShrink={1}>
            <components.TagContent {...commonProps} innerProps={innerProps} />
          </Flex.Item>
        </Flex.Row>
      </div>
    </SortableTagStyled>
  )
}
